import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  useEffect(() => {
    // Dynamically add CSS
    const stylesheets = [
      "/front-end/plugins/bootstrap/bootstrap.min.css",
      "/front-end/plugins/themify-icons/themify-icons.css",
      "/front-end/plugins/slick/slick.css",
      "/front-end/plugins/slick/slick-theme.css",
      "/front-end/plugins/fancybox/jquery.fancybox.min.css",
      "/front-end/plugins/aos/aos.css",
      "/front-end/css/style.css",
    ];
 
    const linkElements = stylesheets.map((href) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
      return link;
    });

    // Dynamically add JS
    const scripts = [
      // "/front-end/plugins/jquery/jquery.min.js",
      // "/front-end/plugins/slick/slick.min.js",
      // "/front-end/js/script.js",
      // "/front-end/plugins/aos/aos.js",
      // "/front-end/plugins/bootstrap/bootstrap.min.js",
      // "/front-end/plugins/fancybox/jquery.fancybox.min.js",
      // "/front-end/plugins/syotimer/jquery.syotimer.min.js",
      // "/front-end/plugins/google-map/gmap.js",
    ];

    const scriptElements = scripts.map((src) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
      return script;
    });

    // Cleanup when layout unmounts
    return () => {
      linkElements.forEach((link) => {
        if (document.head.contains(link)) {
          document.head.removeChild(link);
        }
      });

      scriptElements.forEach((script) => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      });
    };

  }, []);

  return (
    <div className="main-layout" style={{ minHeight: "100vh", paddingBottom: "60px" }}>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;